export default __webpack_public_path__ + "static/media/buster_klein_15.01132738.jpg";